export default {
  beforeDestroy() {
    // Clean up the event listener for modal if the component is destroyed
    this.$el.removeEventListener('keydown', this.handleEscKey);
    this.$el.removeEventListener('keydown', this.onTabKeydown);
  },
  methods: {
    getFocusModal(refOpenFocus, refCloseFocus) {
      // Focus on refObj when - toggleModal opens/closes for simple case
      let refObj = '';
      if (this.showModal) {
        refObj = refOpenFocus;
        this.getFocus(refObj);
        this.modalTrapFocus();
        this.$el.addEventListener('keydown', this.modalHandleEscKey);
      } else {
        refObj = refCloseFocus;
        this.getFocus(refObj);
        this.$el.removeEventListener('keydown', this.modalHandleEscKey);
      }
    },
    getFocus(refObj) {
      // Focus on refObj when action such as modal opens/closes
      if (refObj) {
        refObj.focus();
      }
    },
    modalHandleEscKey(event) {
      // Close the modal if the Esc key is pressed
      if (event.key === 'Escape') {
        this.showModal = !this.showModal;
        if (this.refEle) {
          this.refEle.focus(); // focus to the ref on the component
        }
      }
    },
    onTabKeydown(e, firstFocusableElement, lastFocusableElement) {
      if (e.key === 'Tab') {
        if (e.shiftKey) { // Shift + Tab to go backward
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus();
            e.preventDefault();
          }
        } else if (document.activeElement === lastFocusableElement) {
          firstFocusableElement.focus();
          e.preventDefault();
        }
      }
    },
    modalTrapFocus() {
      const modal = this.$el.getElementsByClassName('modal')[0];
      const focusableElements = modal.querySelectorAll(
        'button, input, select, textarea, [tabindex]:not([tabindex="-1"])',
      );

       // Ensure there are focusable elements in the modal
      if (focusableElements.length === 0) return;

      const firstFocusableElement = focusableElements[0];
      const lastFocusableElement = focusableElements[focusableElements.length - 1];
      // Focus the first element when the modal opens
      firstFocusableElement.focus();
      // Listen for Tab keydown events to trap focus
      // Add event listener to handle Tab key navigation
      this.$el.addEventListener(
        'keydown', (e) =>
        this.onTabKeydown(e, firstFocusableElement, lastFocusableElement)
      );
      // Cleanup the event listener when modal is closed
      this.$once('hook:beforeDestroy', () => {
        this.$el.removeEventListener('keydown', this.onTabKeydown);
      });
    },
  },
};
